import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SmoothScroll from "./SmoothScroll";
import Nav from "./Nav";
import Footer from "./Footer";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function Layout({ children }) {
  return (
    <SmoothScroll>
      <div className="grain relative bg-cream-100 text-ink-800 min-h-screen overflow-x-hidden">
        <ScrollToTop />
        <Nav />
        <main data-testid="site-main" className="relative z-[2]">
          {children}
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
